import React from 'react';

export interface IconProps {
    name: string;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
    title?: string;
    style?: React.CSSProperties;
    'aria-hidden'?: boolean;
}

const sizeMap = {
    xs: 'text-[14px]',
    sm: 'text-[16px]',
    md: 'text-[20px]',
    lg: 'text-[24px]',
    xl: 'text-[32px]'
};

export const Icon: React.FC<IconProps> = ({ name, size = 'md', className = '', title, ...rest }) => (
        <span
            className={`material-symbols-outlined ${sizeMap[size]} leading-none ${className}`}
            title={title}
            aria-hidden={title ? undefined : true}
            {...rest}
        >
            {name}
        </span>
    );














